export const actionTypes = {
  TM_LOADING_START: "TM_LOADING_START",
  TM_LOADING_STOP: "TM_LOADING_STOP",
  TM_SHOW_LIST: "TM_SHOW_LIST",
  TM_ADD_SUCCESS: "TM_ADD_SUCCESS",
  TM_UPDATE_SUCCESS: "TM_UPDATE_SUCCESS",
  TM_DELETE_SOFT: "TM_DELETE_SOFT",
};
